"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var PanelItem_1 = tslib_1.__importDefault(require("./PanelItem"));
var Panel = function (props) {
    var _a;
    var title = props.title, _b = props.dataSource, dataSource = _b === void 0 ? [] : _b, expandable = props.expandable, rowSelection = props.rowSelection, onchange = props.onchange, children = props.children, hasFilter = props.hasFilter, hideTitle = props.hideTitle, singleSelect = props.singleSelect, defaultFocus = props.defaultFocus, className = props.className, lastPanelStyle = props.lastPanelStyle, parentRecord = props.parentRecord, depth = props.depth;
    var expandedRowRender = (expandable || {}).expandedRowRender;
    var _c = rowSelection || {}, selectedRowKeys = _c.selectedRowKeys, focusKeys = _c.focusKeys;
    var onSelect = (0, react_1.useCallback)(function (index, checked) {
        if (selectedRowKeys) {
            var key_1 = (dataSource[index] || {}).key;
            var isAlreadyChecked = selectedRowKeys.includes(key_1);
            if (checked && !isAlreadyChecked) {
                var keys = Array.from(new Set(tslib_1.__spreadArray(tslib_1.__spreadArray([], tslib_1.__read(selectedRowKeys), false), [key_1], false)));
                onchange && onchange(keys);
            }
            else if (!checked && isAlreadyChecked) {
                var keys = selectedRowKeys.filter(function (selectedKey) { return selectedKey !== key_1; });
                onchange && onchange(keys);
            }
        }
    }, [dataSource, selectedRowKeys]);
    var onFocus = function (selectedKey) {
        dataSource.forEach(function (item) {
            var key = item.key;
            item.isFocus = key === selectedKey;
        });
        props.onFocus && props.onFocus(selectedKey);
    };
    var onSelectAll = (0, react_1.useCallback)(function (selected) {
        onchange && onchange(selected ? dataSource.filter(function (i) { return !i.disabled; }).map(function (i) { return i.key; }) : []);
    }, [dataSource]);
    var focusIndex;
    dataSource.forEach(function (item, i) {
        if (defaultFocus && focusKeys.length === 0 && i === 0) {
            focusIndex = i;
        }
        else {
            var key = item.key;
            var isFocus = focusKeys.includes(key);
            if (isFocus) {
                focusIndex = i;
            }
        }
    });
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(PanelItem_1.default, { key: parentRecord === null || parentRecord === void 0 ? void 0 : parentRecord.key, hasFilter: hasFilter, title: title, dataSource: dataSource, onItemFocus: onFocus, singleSelect: singleSelect, rowSelection: rowSelection, onSelect: onSelect, onSelectAll: onSelectAll, hideTitle: hideTitle, defaultFocus: defaultFocus, hasChild: !!expandedRowRender, className: className, lastPanelStyle: lastPanelStyle, parentRecord: parentRecord, depth: depth }),
        expandedRowRender &&
            expandedRowRender((_a = dataSource[focusIndex]) === null || _a === void 0 ? void 0 : _a.children, dataSource[focusIndex]),
        children));
};
exports.default = Panel;
//# sourceMappingURL=Panel.js.map